import RecordDetail from "../components/generated-records/RecordDetail2";

const RecordDetailPage = () => {
  return (
    <>
      <RecordDetail />
    </>
  );
};

export default RecordDetailPage;
